import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const PrivateRoute = ({ children }) => {
  const { user, loading, hasStoredSession, sessionLoadError, retrySessionLoad, logout } = useAuth();
  const { t } = useTranslation();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  // Token exists but /me failed for a non-auth reason (network/5xx). Do not dump
  // the user on the login page — that looks like a spontaneous logout.
  if (!user && hasStoredSession && sessionLoadError) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        gap={2}
        px={2}
        textAlign="center"
      >
        <Typography variant="h6">{t('auth.sessionReconnectTitle')}</Typography>
        <Typography color="text.secondary" maxWidth={420}>
          {t('auth.sessionReconnectBody')}
        </Typography>
        <Box display="flex" gap={1} flexWrap="wrap" justifyContent="center">
          <Button variant="contained" onClick={retrySessionLoad}>
            {t('auth.retryConnection')}
          </Button>
          <Button variant="outlined" onClick={logout}>
            {t('nav.logout')}
          </Button>
        </Box>
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;
